export const updatePWADisplay = () => {
	const manifestLink = document.querySelector('link[rel="manifest"]') as HTMLLinkElement;

	if (!manifestLink) {
		return;
	}

	if (!manifestLink.dataset.originalHref) {
		manifestLink.dataset.originalHref = manifestLink.href;
	}

	fetch(manifestLink.dataset.originalHref)
		.then((response) => response.json())
		.then((manifest) => {
			const updatedManifest = {
				...manifest,
				display: 'browser',
			};

			const blob = new Blob([JSON.stringify(updatedManifest)], { type: 'application/json' });
			const newManifestURL = URL.createObjectURL(blob);

			if (manifestLink.href.startsWith('blob:')) {
				URL.revokeObjectURL(manifestLink.href);
			}

			manifestLink.href = newManifestURL;
		})
		.catch((error) => {
			console.error('Error updating PWA display mode:', error);
		});
};
